import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import { resetProcess, setVideoUrl } from 'src/store/slices/sentinel';
import { useAppDispatch, useAppSelector } from 'universal-scripts';

export function useProcessActions() {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const intl = useIntl();

	const status = useAppSelector((state) => state.sentinel.status);
	const videoUrl = useAppSelector((state) => state.sentinel.videoUrl);
	const refreshCache = useAppSelector((state) => state.sentinel.refreshCache);

	const retry = useCallback(() => {
		if (videoUrl) {
			dispatch(setVideoUrl({ url: videoUrl, refreshCache }));
		}
	}, [dispatch, videoUrl, refreshCache]);

	const startNewAnalysis = useCallback(() => {
		if (status === 'processing') {
			const confirmMessage = intl.formatMessage({ id: 'sentinel.process-view.active-process' });
			if (!window.confirm(confirmMessage)) {
				return;
			}
		}

		if (status !== 'idle') {
			dispatch(resetProcess());
		}

		navigate('/sentinel');
	}, [navigate, status, intl, dispatch]);

	return {
		retry,
		startNewAnalysis,
		status,
		hasVideoUrl: !!videoUrl
	};
}
